export const TRANSLATIONS_SV = {
  navbar: {
    home: "Hem",
    lifestyle_surveys: "Livskvalitetsenkäter",
    symptoms_diary: "Symtomdagboken",
    antibiotics: "Antibiotika",
    immunglobulin: "Immunglobulin",
    sick_days: "Sjukdagar",
    care_days: "Vårddagar",
    vaccination: "Vaccination",
    my_notes: "Mina anteckningar",
    calendar: "Kalender",
    help: "Hjälp",
    about: "Om hälsodagboken",
    sign_out: "Logga ut",
  },
  alert_dialog: {
    ok: "OK",
    cancel: "Avbryt",
  },
  customform: {
    editing_mode: "Redigeringsläge",
    cancel: "Avbryt",
    discard_changes: "Släng ändringar",
    discard_changes_confirmation_text:
      "Är du säker på att du vill slänga ändringarna?",
  },
  forms: {
    eq_5d_5l: {
      value_slider: {
        title: "Självuppskattat hälsotillstånd",
        description_1:
          "(100 = ditt bästa tänkbara hälsotillstånd. 0 = ditt sämsta tänkbara hälsotillstånd).",
        description_2: "Dra reglaget till önskat värde.",
        value: "Nuvarande värde: {{value}}",
      },
    },
    validation: {
      is_greater_than: "Värdet måste vara större än {{target}}",
      is_not_one_of: "Värdet får inte vara ett av {{target}}",
      is_less_than: "Värdet måste vara mindre än {{target}}",
      is_greater_than_or_equal_to:
        "Värdet måste vara större än eller lika med {{target}}",
      is_less_than_or_equal_to:
        "Värdet måste vara mindre än eller lika med {{target}}",
      is_not_equal_to: "Värdet får inte vara lika med {{target}}",
      is_equal_to: "Värdet måste vara lika med {{target}}",
      is_not_null_or_empty: "Fältet får inte vara tomt",
      is_empty: "Array kan inte vara tom",
      has_minimum_length: "Array måste ha minst {{target}} element",
      has_maximum_length: "Array måste ha högst {{target}} element",
      is_before: "Datum måste vara före {{target}}",
      is_same_or_before: "Datum måste vara på eller före {{target}}",
      is_after: "Datum måste vara efter {{target}}",
      is_same_or_after: "Datum måste vara på eller efter {{target}}",
      is_not_in_future: "Datumet får inte vara i framtiden",
    },
  },
  success: {
    saveMeasurement: "Formuläret har sparats",
    updateMeasurement: "Uppdatering lyckades",
    saveTreatment: "Behandlingen har sparats",
    updateTreatment: "Behandlingen har uppdaterats",
    saveForm: "Formuläret har sparats",
    updateForm: "Formuläret har uppdaterats",
  },
  error: {
    saveMeasurement: "Formuläret misslyckades",
    updateMeasurement: "Uppdatering misslyckades",
    saveTreatment: "Behandlingen misslyckades",
    updateTreatment: "Behandlingen misslyckades",
    saveForm: "Formuläret kunde inte sparas",
    updateForm: "Formuläret kunde inte sparas",
  },
  symptomdiary: {
    info: "Symtomdagboken fyller du i veckovis. Sätt en bock för de symtom du haft under veckan. I diagrammet nedan kan du följa dina symtom över tid. Var gärna lite extra uppmärksam när du registrerar värden då det enda du kan redigera i efterhand är att lägga till ett symptom. Man kan alltså inte ändra vecka, år eller ta bort ett tidigare registrerad symtom.",
  },
  antibiotics: {
    info: "Här registrerar du den antibiotikabehandling du tar. Registrera det datumintervall du tar antibiotikan. Om du byter antibiotika under en kur så avslutar du den första antibiotikan genom att skriva in slut-datumet den dag du tar sista tabletten/sprutan och påbörjar en ny registrering med det nya preparatet.",
  },
  immunoglobulin: {
    info: "Här fyller du i när du tagit din immunglobulinbehandling. Fyll i datum, den dos i ml du tog samt Batch-/Lot-numret. Om du vid samma behandling använder fler än ett batchnummer skriv dessa efter varandra med ett kommatecken (,) emellan.",
  },
  sickdays: {
    info: "Här registreras de dagar du varit så sjuk att du inte kunnat utföra dina dagliga aktiviteter samt de dagar du varit hemma från jobb/skola eller avstått från planerade aktiviteter på grund av sjukdom.",
  },
  caredays: {
    info: "Här registreras de dagar du vårdas på sjukhus. Skriv till- och från-datum samt ange om sjukhusvistelsen var på grund av en infektion. I tabellen samt grafen nedan kan du se dina vårddagar över tid.",
  },
  vaccinations: {
    info1:
      "Här registrerad du dina vaccinationer. Fyll i det datum du tar vaccinationen och välj i listan vilken vaccination det gäller. Fråga vaccinatören om namn på vaccinet.",
    info2: "I tabellen nedan kan du se dina vaccinationer över tid.",
  },
  mynotes: {
    info: "Här kan du skriva din diagnos, övrig behandling, egna anteckningar t ex sådant du vill komma ihåg att ta upp vid nästa kontakt med din mottagning. Dessa uppgifter är bara till för dig, de förs inte över till PIDcare och kan inte ses av din läkare eller sjuksköterska.",
  },
  calendar: {
    info: "Här kan du se dina registreringar över tid. Du kan välja om du vill se informationen dag-, vecko- eller månadsvis.",
  },
};
